import { createContext, useContext } from 'react'
import type { AdminSectionRouteName, AdminSectionParams } from './adminRoutes'

export interface AdminShellNavigate {
  <R extends AdminSectionRouteName>(route: R, params?: AdminSectionParams[R]): void
}

export interface AdminShellContextValue {
  navigateTo: AdminShellNavigate
}

export const AdminShellContext = createContext<AdminShellContextValue | null>(null)

export function useAdminShell(): AdminShellContextValue {
  const ctx = useContext(AdminShellContext)
  if (!ctx) throw new Error('useAdminShell must be used inside AdminShell')
  return ctx
}